import FirstForm from '../../../components/FirstForm/FirstForm.jsx';

function FirstFormContainer() {

    return (
        <FirstForm />
    );
  }
  
  export default FirstFormContainer;